export const WrapperRow = ({LinksCol, RightCol}) => {
    return(
        <div class="row">
            <LinksCol />
            <RightCol />
        </div>
    );
}